import { ref } from 'vue';

export class DeadlineFormField {
	public readonly isAnytime = ref<boolean>(false);
	public readonly isNotSpecified = ref<boolean>(false);
	public readonly isSpecified = ref<boolean>(false);
	public readonly date = ref<string>();

	public noSelectionMade(): boolean {
		return !this.isAnytime.value && !this.isNotSpecified.value && !this.isSpecified.value;
	}
}
